export default __webpack_public_path__ + "813c94e44df720e3bef3aaa2edb80ea5.png";